export default __webpack_public_path__ + "static/help-program-9a6be8ae21a76bbde66daa8b30e7e79c.png";